// pbiAdapter.js
/**
 * Maps a server-side ReportItem object to Power BI embed parameters.
 * Supports two patterns:
 *  A) Explicit fields: PbiReportId, PbiWorkspaceId, PbiTenantId (and optional PbiEmbedUrl)
 *  B) A full embed URL held in ReportURL or PbiEmbedUrl with reportId/groupId/ctid query params
 */
export function mapReportItemToPbi(row) {
  if (!row) return null;

  // Option A: dedicated fields
  const reportId = row?.PbiReportId || null;
  const groupId  = row?.PbiWorkspaceId || null;
  const ctid     = row?.PbiTenantId || null;
  if (reportId && groupId && ctid) return { reportId, groupId, ctid };

  // Option B: parse a URL
  const url = row?.PbiEmbedUrl || row?.ReportURL || "";
  try {
    const u = new URL(url);
    const rid = u.searchParams.get("reportId");
    const gid = u.searchParams.get("groupId");
    const t   = u.searchParams.get("ctid");
    if (rid && gid && t) return { reportId: rid, groupId: gid, ctid: t };
  } catch (_) { /* ignore invalid URLs */ }

  return null;
}
